import { manufacturerSlice } from '@client/manufacturer/redux/manufacturer/redux';
import { manufacturersSlice } from '@client/manufacturer/redux/manufacturers/redux';
import { combineSlices } from '@reduxjs/toolkit';

export const manufacturerReducer = combineSlices(
  manufacturerSlice,
  manufacturersSlice,
);
